import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowChangeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M3.32004 11.96C3.74004 8.46 6.20004 5.64 9.42004 4.64V5.84C9.41004 6.31 9.96004 6.63 10.36 6.38L14.48 4C14.89 3.78 14.89 3.14 14.48 2.92L10.36 0.539999C9.96004 0.289999 9.41004 0.619999 9.42004 1.08V2.57C5.17004 3.63 1.87004 7.21 1.33004 11.72C1.26004 12.31 1.73004 12.84 2.32004 12.84C2.82004 12.84 3.25004 12.47 3.31004 11.96H3.32004Z"
        fill={color}
      />
      <path
        d="M15.44 21.04C12.2 22.43 8.53004 21.71 6.05004 19.41L7.09004 18.81C7.50004 18.59 7.50004 17.95 7.09004 17.73L2.97004 15.35C2.57004 15.11 2.02004 15.42 2.03004 15.89V20.65C2.02004 21.12 2.57004 21.44 2.97004 21.19L4.27004 20.44C6.31004 22.56 9.11004 23.74 12.01 23.74C13.43 23.74 14.86 23.46 16.24 22.87C16.75 22.65 16.98 22.06 16.76 21.56C16.54 21.05 15.95 20.81 15.45 21.04H15.44Z"
        fill={color}
      />
      <path
        d="M23.61 16.73L22.32 15.99C23.53 11.78 22.08 7.14 18.44 4.41C18 4.08 17.37 4.17 17.04 4.61C16.71 5.05 16.8 5.68 17.24 6.01C20.07 8.12 21.27 11.66 20.52 14.95L19.48 14.35C19.08 14.11 18.53 14.42 18.54 14.89V19.65C18.53 20.12 19.08 20.44 19.48 20.19L23.6 17.81C24.01 17.59 24.01 16.95 23.6 16.73H23.61Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowChangeIcon.displayName = 'ArrowChangeIcon';
